import { render, staticRenderFns } from "./inbdetailsgridedit.vue?vue&type=template&id=610a5bc9"
import script from "./inbdetailsgridedit.vue?vue&type=script&lang=js"
export * from "./inbdetailsgridedit.vue?vue&type=script&lang=js"
import style0 from "./inbdetailsgridedit.vue?vue&type=style&index=0&id=610a5bc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports